import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"
import {AutoCompleteProducts} from "../../models/autocomplete"
import {EnrichedMaxItemsConfig} from "../../models/search"

export type AutocompleteProductsProps = {
    products: AutoCompleteProducts[] | null
    term: string | any
    maxItems: EnrichedMaxItemsConfig
    handleSuggestionClick: (suggestion: string, siteUrl: string) => void
    text: any
    currencyCode: string
    locale: string
    siteUrl: string
    realm?: string
    threeFourImageryEnabled: boolean
    enrichedSearchImagePath: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    isTPClient: boolean
    variant: string
    iconsVersionPath: string
    isRTL: boolean
    xxlBreakpointEnabled: boolean
    cleanSiteUrl: string
    isTpSuperLite: boolean
}

export const AutocompleteProducts = memo<AutocompleteProductsProps>(function AutocompleteProductsMemo({
    templating,
    ...props
}) {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName {...props} />
        </Suspense>
    )
})
AutocompleteProducts.displayName = "AutocompleteProducts"

export default connect(AutocompleteProducts)
